import React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { Toast } from "antd-mobile";
import { getItem } from "../../util/util";

const withAuth = WrappedComponet => {
  return withRouter(
    class extends React.Component {
      state = {
        isLogin: getItem("userInfo")
      };
      componentDidMount() {
        if (!this.state.isLogin) {
          Toast.info("请先登录", 1);
        }
      }
      render() {
        return this.state.isLogin ? (
          <WrappedComponet {...this.props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: this.props.match.url }
            }}
          />
        );
      }
    }
  );
};

export default withAuth;
